module.exports = __webpack_public_path__ + "static/3-5cc699d07568ca7d799934924ff7b35e.jpg";